module.exports = __webpack_public_path__ + "10ee6151395821d476ca2d5496442014.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/money-swap-bg.png
 ** module id = 1542
 ** module chunks = 0
 **/